import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function AboutCinCinSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      data-testid="about-cincin-section"
      ref={ref}
      className="bg-[#EFEAE6] pt-10 md:pt-16 pb-20 md:pb-32 px-6 md:px-16 lg:px-24"
    >
      <div className="max-w-[1200px] mx-auto">
        {/* Heading — left-aligned, same grid as testimonials */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
        >
          <span
            data-testid="about-cincin-heading"
            className="label-text"
          >
            About CinCin
          </span>
          <div className="editorial-line mt-4 mb-14 md:mb-20" />
        </motion.div>

        {/* Body text — left-aligned, controlled width for readability */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, delay: 0.15 }}
          className="max-w-[720px]"
        >
          <p className="font-serif text-base sm:text-lg leading-[2] text-[#0A0A0A]/75">
            CinCin creates experiences that are deeply personal, thoughtfully designed, and impossible to replicate.
          </p>

          <p className="font-serif text-base sm:text-lg leading-[2] text-[#0A0A0A]/75 mt-8 md:mt-10">
            Every celebration begins with a story; and through an intuitive understanding of vision, audience, and emotion, we translate that story into space, detail, and atmosphere.
          </p>

          <p className="font-serif text-base sm:text-lg leading-[2] text-[#0A0A0A]/75 mt-8 md:mt-10">
            From intimate gatherings to large-scale productions, our approach blends creative direction with executional precision, we believe in delivering experiences that feel effortless, yet are meticulously crafted.
          </p>

          {/* Block 4 — emphasis */}
          <div className="mt-12 md:mt-16">
            <p className="font-serif text-lg sm:text-xl italic leading-[2] text-[#0A0A0A]/70">
              At its core, CinCin is not just about events.<br />
              It is about creating moments that stay.
            </p>
          </div>

          {/* Block 5 — signature */}
          <div className="mt-10 md:mt-14">
            <p className="text-xs tracking-[0.2em] uppercase text-[#0A0A0A]/40 font-light">
              Because CinCin is the sound of celebration.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
